<template>
  <v-container
    id="dashboard"
    fluid
    tag="section"
  >
    <v-row>
      <v-col>
        <v-progress-linear
          :active="loading"
          :indeterminate="loading"
          absolute
          color="primary"
        />
      </v-col>
    </v-row>
    <sequential-entrance from-top>
      <v-row>
        <v-col
          sm="12"
          md="12"
          lg="12"
        >
          <base-material-card
            color="primary"
            icon="mdi-group"
            inline
          >
            <template v-slot:after-heading>
              <div class="display-2 font-weight-light">
                Billing Client Mangement
              </div>
            </template>
            <v-data-table
              :headers="headers"
              :items="getrels"
              :search="search"
              class="elevation-1"
            >
              <template v-slot:top>
                <v-toolbar
                  flat
                >
                  <v-toolbar-title>Clients</v-toolbar-title>
                  <v-divider
                    class="mx-4"
                    inset
                    vertical
                  />
                  <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Search"
                    single-line
                    hide-details
                  />
                  <v-spacer />
                  <v-dialog
                    v-model="dialog"
                    max-width="500px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        color="primary"
                        dark
                        class="mb-2"
                        v-bind="attrs"
                        v-on="on"
                      >
                        New Client
                      </v-btn>
                    </template>

                    <v-card>
                      <v-card-title>
                        <span class="headline">{{ formTitle }}</span>
                      </v-card-title>

                      <v-card-text>
                        <v-col>
                          <validation-observer
                            ref="observer"
                            v-slot="{ invalid }"
                          >
                            <form @submit.prevent="submit">
                              <validation-provider
                                v-slot="{ errors }"
                                name="Name"
                                rules="required|max:30"
                              >
                                <v-text-field
                                  v-model="editedItem.name"
                                  :error-messages="errors"
                                  label="Company Name"
                                  required
                                />
                              </validation-provider>
                              <validation-provider
                                v-slot="{ errors }"
                                name="Contact"
                                rules="required|max:20"
                              >
                                <v-text-field
                                  v-model="editedItem.contact"
                                  :error-messages="errors"
                                  label="Contact Name"
                                  required
                                />
                              </validation-provider>
                              <validation-provider
                                v-slot="{ errors }"
                                name="phoneNumber"
                                :rules="{ required: true, regex: /^[- +()]*[0-9][- +()0-9]*$/, min: 14, max: 14 }"
                              >
                                <v-text-field
                                  v-model="editedItem.phone"
                                  v-mask="'(###)-###-####'"
                                  :counter="14"
                                  :error-messages="errors"
                                  label="Phone Number"
                                  required
                                />
                              </validation-provider>
                              <validation-provider
                                v-slot="{ errors }"
                                name="email"
                                rules="required|email"
                              >
                                <v-text-field
                                  v-model="editedItem.email"
                                  :error-messages="errors"
                                  label="E-mail"
                                  required
                                />
                              </validation-provider>

                              <validation-provider
                                v-slot="{ errors }"
                                name="address"
                                rules="required"
                              >
                                <v-text-field
                                  v-model="editedItem.address"
                                  :error-messages="errors"
                                  label="address"
                                  required
                                />
                              </validation-provider>
                              <validation-provider
                                v-slot="{ errors }"
                                name="city"
                                rules="required"
                              >
                                <v-text-field
                                  v-model="editedItem.city"
                                  :error-messages="errors"
                                  label="city"
                                  required
                                />
                              </validation-provider>
                              <validation-provider
                                v-slot="{ errors }"
                                name="state"
                                rules="required"
                              >
                                <v-autocomplete
                                  v-model="editedItem.state"
                                  :items="getstates"
                                  :error-messages="errors"
                                  label="state"
                                  required
                                />
                              </validation-provider>
                              <validation-provider
                                v-slot="{ errors }"
                                name="zip"
                                :rules="{
                                  required: true,
                                  digits: 5,
                                }"
                              >
                                <v-text-field
                                  v-model="editedItem.zip"
                                  :error-messages="errors"
                                  label="zip"
                                  required
                                />
                              </validation-provider>
                              <v-btn
                                class="mr-4"
                                type="submit"
                                :disabled="invalid"
                                @click="save"
                              >
                                save
                              </v-btn>
                              <v-btn @click="close">
                                close
                              </v-btn>
                            </form>
                          </validation-observer>
                        </v-col>
                      </v-card-text>
                    </v-card>
                  </v-dialog>
                  <v-dialog
                    v-model="dialogDelete"
                    max-width="600px"
                  >
                    <v-card>
                      <v-card-title class="headline">
                        Are you sure you want to delete this item?
                      </v-card-title>
                      <v-card-actions>
                        <v-spacer />
                        <v-btn
                          color="blue darken-1"
                          text
                          @click="closeDelete"
                        >
                          Cancel
                        </v-btn>
                        <v-btn
                          color="blue darken-1"
                          text
                          @click="deleteItemConfirm"
                        >
                          OK
                        </v-btn>
                        <v-spacer />
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-toolbar>
              </template>
              <template v-slot:[`item.actions`]="{ item }">
                <v-btn
                  small
                  class="mr-2 warning"
                  @click="editItem(item)"
                >
                  Edit Item
                </v-btn>
              </template>
              <template v-slot:no-data>
                <v-btn
                  color="primary"
                  @click="initialize"
                >
                  Reset
                </v-btn>
              </template>
            </v-data-table>
          </base-material-card>
        </v-col>
      </v-row>
    </sequential-entrance>
  </v-container>
</template>

<script>
  export default {
    data: () => ({
      dialog: false,
      dialogDelete: false,
      search: '',
      headers: [
        {
          text: 'Client Name',
          align: 'start',
          sortable: true,
          value: 'name',
        },
        {
          text: 'Address',
          align: 'center',
          sortable: true,
          value: 'address',
        },
        {
          text: 'Contact',
          align: 'center',
          sortable: true,
          value: 'contact',
        },
        {
          text: 'Phone',
          align: 'center',
          sortable: true,
          value: 'phone',
        },
        {
          text: 'Email',
          align: 'center',
          sortable: true,
          value: 'email',
        },
        { text: 'Actions', value: 'actions', align: 'center', sortable: false },
      ],
      rels: [],
      editedIndex: -1,
      editedItem: {
        name: '',
        address: '',
        state: '',
        zip: '',
        contact: '',
        phone: '',
        email: '',
        key: '',
      },
      defaultItem: {
        name: '',
        address: '',
        state: '',
        zip: '',
        contact: '',
        phone: '',
        email: '',
        key: '',
      },
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'New Billing Client' : 'Edit Billing Client'
      },
      loading () {
        // return true
        return this.$store.getters.getloading
      },
      getrels () {
        this.rels = []
        this.rels = this.$store.getters.getbillingclients

        return this.rels
      },
      getstates () {
        let state_hash = [
          'AL',
          'AK',
          'AS',
          'AZ',
          'AR',
          'CA',
          'CO',
          'CT',
          'DE',
          'DC',
          'FM',
          'FL',
          'GA',
          'GU',
          'HI',
          'ID',
          'IL',
          'IN',
          'IA',
          'KS',
          'KY',
          'LA',
          'ME',
          'MH',
          'MD',
          'MA',
          'MI',
          'MN',
          'MS',
          'MO',
          'MT',
          'NE',
          'NV',
          'NH',
          'NJ',
          'NM',
          'NY',
          'NC',
          'ND',
          'MN',
          'MP',
          'OH',
          'OK',
          'OR',
          'PW',
          'PA',
          'PR',
          'RI',
          'SC',
          'SD',
          'TN',
          'TX',
          'UT',
          'VT',
          'VI',
          'VA',
          'WA',
          'WV',
          'WI',
          'WY'
        ]
        return state_hash
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
    },

    created () {
      this.rels = []
      this.$store.dispatch('loadbillingclients')
      this.initialize()
    },

    methods: {
      initialize () {
        this.rels = this.$store.getters.getbillingclients
      },

      editItem (item) {
        this.editedIndex = this.rels.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      deleteItem (item) {
        this.editedIndex = this.rels.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },

      deleteItemConfirm () {
        this.rels.splice(this.editedIndex, 1)
        // this.$store.dispatch('removerelease', this.editedItem)
        console.log('remove entry ', this.editedItem)
        this.closeDelete()
      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      save () {
        if (this.editedIndex > -1) {
          Object.assign(this.rels[this.editedIndex], this.editedItem)
          console.log('save this edited item ', this.editedItem)
          this.$store.dispatch('updatebillingclient', this.editedItem)
        } else {
          this.rels.push(this.editedItem)
          console.log('save this new item ', this.editedItem)

          this.$store.dispatch('createbillingclient', this.editedItem)
        }
        this.$store.dispatch('loadbillingclients')
        this.close()
      },
    },
  }
</script>
